/**
 * 排课显示时区：用户选择的时区仅影响前端展示，切换后所有排课时间按该时区显示。
 * 依赖 dayjs + utc + timezone 插件。
 */
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export const STORAGE_KEY_SCHEDULE_TIMEZONE = 'schedule_display_timezone';

const DEFAULT_TZ = 'Asia/Shanghai';

/** 与会员管理时区选项一致 */
export const SCHEDULE_TIMEZONE_OPTIONS = [
  { value: 'Asia/Shanghai', label: '北京时间 (Asia/Shanghai)' },
  { value: 'Europe/Paris', label: '巴黎 (Europe/Paris)' },
  { value: 'Europe/London', label: '伦敦 (Europe/London)' },
  { value: 'America/New_York', label: '纽约 (America/New_York)' },
  { value: 'America/Los_Angeles', label: '洛杉矶 (America/Los_Angeles)' },
  { value: 'Asia/Tokyo', label: '东京 (Asia/Tokyo)' },
  { value: 'Australia/Sydney', label: '悉尼 (Australia/Sydney)' },
];

export function getScheduleTimezone() {
  const tz = (typeof localStorage !== 'undefined' && localStorage.getItem(STORAGE_KEY_SCHEDULE_TIMEZONE)) || '';
  return tz && SCHEDULE_TIMEZONE_OPTIONS.some((o) => o.value === tz) ? tz : DEFAULT_TZ;
}

export function setScheduleTimezone(tz) {
  if (typeof localStorage !== 'undefined') {
    if (tz) localStorage.setItem(STORAGE_KEY_SCHEDULE_TIMEZONE, tz);
    else localStorage.removeItem(STORAGE_KEY_SCHEDULE_TIMEZONE);
  }
}

/**
 * 将 API 返回的 ISO 时间字符串在「排课显示时区」下格式化为指定格式。
 * @param {string} isoString - 如 "2026-03-06T00:37:00+08:00" 或带 Z 的 UTC
 * @param {string} formatStr - dayjs 格式，如 'HH:mm'、'YYYY-MM-DD HH:mm'
 * @returns {string} 格式化后的字符串
 */
export function formatScheduleTime(isoString, formatStr = 'YYYY-MM-DD HH:mm') {
  if (!isoString) return '';
  const tz = getScheduleTimezone();
  const d = dayjs(isoString);
  if (!d.isValid()) return '';
  return d.tz(tz).format(formatStr);
}

/**
 * 返回在排课显示时区下的 dayjs 对象，便于做 date()、hour() 等计算（如按“显示日期”分组）。
 */
export function dayjsInScheduleTz(isoString) {
  if (!isoString) return null;
  const tz = getScheduleTimezone();
  const d = dayjs(isoString).tz(tz);
  return d.isValid() ? d : null;
}
